if (!customElements.get("our-team-slider")) {
    customElements.define(
      "our-team-slider",
      class OurTeamSlider extends HTMLElement {
        constructor() {
          super();
          this.slider = null;
          this.swiper = null;
          this.handleResize = this.handleResize.bind(this);
        }
  
        connectedCallback() {
          this.id = this.id;
          this.slider = this.querySelector('.our-team-slider__slider');
  
          if (this.slider) {
            this.handleResize(); // перевірка при завантаженні
            window.addEventListener('resize', this.handleResize);
          }
        }
  
        disconnectedCallback() {
          window.removeEventListener('resize', this.handleResize);
          this.destroySlider();
        }
  
        handleResize() {
          const screenWidth = window.innerWidth;
  
          if (screenWidth < 767) {
            this.destroySlider();
          } else {
            if (!this.swiper) {
              this.initSlider();
            }
          }
        }
  
        initSlider() {
          this.swiper = new Swiper(this.slider, {
            slidesPerView: 1.3,
            spaceBetween: 16,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
            speed: 500,
            loop: false,
            navigation: {
              nextEl: `#${this.id} .swiper-button-next`,
              prevEl: `#${this.id} .swiper-button-prev`
            },
            breakpoints: {
              768: {
                slidesPerView: 2.3,
                slidesOffsetBefore: 48,
                slidesOffsetAfter: 48
              },
              1000: {
                slidesPerView: 1.8,
                slidesOffsetBefore: 48,
                slidesOffsetAfter: 48
              },
              1200: {
                slidesPerView: 2.2,
                spaceBetween: 24,
                slidesOffsetBefore: 48,
                slidesOffsetAfter: 48
              }
            }
          });
        }
  
        destroySlider() {
          if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
          }
        }
      }
    );
  }